import { useParams } from "react-router-dom";
import Card from "../../components/common/Card";
import { ColumnsType } from "antd/es/table";
import moment from "moment";

import { useOrderCancelReasons, useOrderDetail } from "../../hooks/useOrders";
import { Box, Skeleton, styled } from "@mui/material";
import Table from "../../components/common/Table";
import { Button, Col, Input, Modal, Row, Select, message } from "antd";
import { useState } from "react";
import api from "../../hooks/api";
import { pathAPI } from "../../utils/pathApi";
import { useBreadcrumbLabel } from "../../components/breadcrumb/BreadcrumbContext";
import { orderStatusPillClass, orderStatusLabel } from "../../theme/statusColors";

const OrderDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [{ data, isLoading }, { mutate }] = useOrderDetail({ id });
  useBreadcrumbLabel(data?.order_detail?.code);
  const [open, setOpen] = useState(false);
  const PaymentMethod = {
    CASH: "Cash",
    GOOGLE_PAY: "Google Pay",
    APPLE_PAY: "Apple Pay",
    PAYPAL: "Paypal",
    STRIPE: "Stripe",
  };
  const status = () => {
    const value = data?.order_detail.status;
    return (
      <div className={`px-2 rounded-lg font-bold ${orderStatusPillClass(value)}`}>
        {orderStatusLabel(value)}
      </div>
    );
  };

  const columns: ColumnsType<OrderDetail["items"]> = [
    {
      title: "#",
      key: "id",
      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "Service",
      key: "Service",
      dataIndex: "name",
    },
    {
      title: "Status",
      key: "Status",
      dataIndex: "status",
    },
    {
      title: "Price",
      key: "Price",
      dataIndex: "amount",
    },

    {
      title: "Discount",
      key: "Discount",
      dataIndex: "discount_amount",
    },
    {
      title: "Total",
      key: "Total",
      dataIndex: "total_amount",
    },
  ];
  return (
    <Box>
      <Box fontWeight={"bold"} fontSize="24px" mb={2}>
        Order Detail
      </Box>
      {isLoading && (
        <Box
          component={Skeleton}
          variant="rectangular"
          width={"100%"}
          height={250}
          borderRadius={"8px"}
        />
      )}
      {!isLoading && (
        <Card>
          <Box display={"flex"} flexWrap={"wrap"}>
            <Box flex={1}>
              <Box>
                <Box
                  mb={2}
                  fontSize={18}
                  borderBottom={"3px solid #ba2156"}
                  display={"inline-block"}
                >
                  CUSTOMER
                </Box>
                <InfoRow>
                  <Title>Name:</Title>
                  <Value>{data?.customer.contact_name || ""}</Value>
                </InfoRow>
                <InfoRow>
                  <Title>Phone:</Title>
                  <Value>{data?.customer.contact_phone || ""}</Value>
                </InfoRow>
                <InfoRow>
                  <Title>Email:</Title>
                  <Value>{data?.customer.contact_email || ""}</Value>
                </InfoRow>
              </Box>
              {(data?.order_detail.status === "ORDER" ||
                data?.order_detail.status === "CREATE") && (
                <Button
                  onClick={() => setOpen(true)}
                  style={{
                    width: "200px",
                    height: "40px",
                    borderRadius: "10px",
                    backgroundColor: "#ba2156",
                    color: "#fff",
                  }}
                >
                  Cancel Order
                </Button>
              )}
            </Box>
            <Box flex={1}>
              <Box
                mb={2}
                fontSize={18}
                borderBottom={"3px solid #ba2156"}
                display={"inline-block"}
              >
                ORDER DETAILS
              </Box>
              <Box>{data?.order_detail.outlet_name}</Box>
              <InfoRow>
                <Title>Order Number:</Title>
                <Value>{data?.order_detail.code || ""}</Value>
              </InfoRow>
              <InfoRow>
                <Title>Order Status:</Title>
                <Value>{status() || ""}</Value>
              </InfoRow>
              <InfoRow>
                <Title>Start time:</Title>
                <Value>
                  {data?.order_detail.start_date
                    ? moment(data.order_detail.start_date).format(
                        "YYYY/MM/DD HH:mm:ss"
                      )
                    : "-"}
                </Value>
              </InfoRow>
              <InfoRow>
                <Title>Payment method:</Title>
                <Value>
                  {data?.order_detail.payment_method_enum
                    ? PaymentMethod[data?.order_detail.payment_method_enum]
                    : ""}
                </Value>
              </InfoRow>
              <InfoRow>
                <Title>Note:</Title>
                <Value>{data?.order_detail.notes || ""}</Value>
              </InfoRow>
            </Box>
          </Box>
        </Card>
      )}

      <Box component={Card} mt={3}>
        <Box
          mb={2}
          fontSize={18}
          borderBottom={"3px solid #ba2156"}
          display={"inline-block"}
        >
          APPOINTMENTS
        </Box>
        <Table
          dataSource={data?.items || []}
          columns={columns}
          loading={isLoading}
        />
      </Box>
      <CancelModal mutate={mutate} open={open} setOpen={setOpen} />
    </Box>
  );
};
export default OrderDetail;

const InfoRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  margin: `0 0 ${theme.spacing(2)} 0`,
}));
const Title = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));
const Value = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  fontWeight: "normal",
}));

const CancelModal = ({
  open,
  setOpen,
  mutate,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  mutate: () => void;
}) => {
  const { id } = useParams<{ id: string }>();
  const [{ data, isLoading }] = useOrderCancelReasons({ page: 0, size: 1000 });
  const [loading, setLoading] = useState(false);
  const [reasonId, setReasonId] = useState<number>();
  const [note, setNote] = useState("");

  const putCancelReason = async (data: any) => {
    if (!reasonId) {
      message.error("Reason cancel is required");
    } else {
      setLoading(true);
      await api
        .POST(`${pathAPI.orders}/${id}/cancel`, data, {}, true)
        .then(() => {
          message.success("Edit Country Successfully!");
          mutate && mutate();
          setOpen(false);
        })
        .catch(() => message.error("Something went wrong!"))
        .finally(() => setLoading(false));
    }
  };

  return (
    <Modal
      centered
      open={open}
      onCancel={() => setOpen(false)}
      okText="Save"
      cancelText="Cancel"
      title={
        <Box color={"#ba2156"} fontWeight={"bold"}>
          Edit Reason Cancel
        </Box>
      }
      width={"620px"}
      destroyOnClose={true}
      style={{ top: 40, height: "90vh", overflowY: "auto" }}
      okButtonProps={{ style: { background: "#ba2156", border: "none" } }}
      footer={null}
    >
      <Box my={3}>
        <Box mb={1}>Please select a reason for canceling your order?</Box>
        <Select
          onChange={(e) => setReasonId(e)}
          style={{ width: "100%" }}
          placeholder="Select language"
          loading={isLoading}
          options={(data || []).map((i) => ({
            value: i.id,
            label: i.message,
          }))}
        />
      </Box>
      <Box>
        <Box>Note:</Box>
        <Input.TextArea
          rows={3}
          placeholder="Note"
          onChange={(e) => setNote(e.target.value || "")}
        />
      </Box>
      <Box component={Row} gutter={[12, 12]} mt={3}>
        <Col md={12} span={24}>
          <Button
            onClick={() => setOpen(false)}
            disabled={loading}
            style={{
              width: "100%",
              height: "40px",
              borderRadius: "10px",
            }}
          >
            Cancel
          </Button>
        </Col>
        <Col md={12} span={24}>
          <Button
            type="primary"
            htmlType="submit"
            onClick={async () => {
              await putCancelReason({ note, cancel_reason_id: reasonId });
            }}
            className="login-form-button"
            disabled={loading}
            loading={loading}
            style={{
              background: "#ba2156",
              borderColor: "white",
              width: "100%",
              height: "40px",
              borderRadius: "10px",
            }}
          >
            Save
          </Button>
        </Col>
      </Box>
    </Modal>
  );
};
